import HomeSearchExplorerSection from 'ui/snippets/navigation/HomeSearchExplorerSection';

export default HomeSearchExplorerSection;
